export default __webpack_public_path__ + "1cf9d75c4710011bbdb1645ab7cbdd38.svg";